var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PanelHeader"},[_c('DashboardWidthWrapper',[_c('div',{staticClass:"title"},[_vm._t("title")],2),_c('div',{staticClass:"text"},[_vm._t("text")],2),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }